import { utils } from "../utils";
import api from "../api";

class TranslatorService {
  constructor() {
    this.lang = $("html").attr("lang") || "ru";
    this.messages = {};
  }
  
  /**
   * Получить все переводы
   * @return {Promise}
   */
  getLanguages() {
    return new Promise((resolve, reject) => {
      let messagesFromStorage = null;
      try {
        messagesFromStorage = utils.getObjectFromSessionStorage("messages")
      } catch (err) {
        console.log(err);
        alert(`Произошла ошибка переводчика!\n${err.message}`);
      }

      /* Если есть в сесси то возвращаем оттуда */
      if (messagesFromStorage && messagesFromStorage.main && messagesFromStorage.main.lang) {
        if (this.lang === messagesFromStorage.main.lang) {
          return resolve(this.messages = messagesFromStorage);
        }
      }
  
      /* Иначе запрашиваем новые */
      return api.language.getAllDictionary(this.lang).then(res => {
        this.messages = res;
        utils.setObjectToSessionStorage("messages", this.messages);
        return resolve(this.messages);
      });
      
    });
  }
  
  /**
   * Получить перевод слова
   * @param category {String}
   * @param message {String}
   * @param params {Object}
   * @return {String}
   */
  t(category, message, params = {}) {
    if (!this.messages[category]) return message;
    
    return this.messages[category][message] ? this.messages[category][message] : message;
  }
}

export const translator = new TranslatorService();
